<template>
  <div class="block-header">
    <div class="block-icon">
      <i class="fas fa-crown"></i>
      <div class="icon-glow"></div>
    </div>
    <h3 class="block-title">{{ title }}</h3>
    <DecoratorLine />
    <div class="block-subtitle">{{ subtitleEn }}</div>
    <div class="block-title-sub">{{ subtitle }}</div>
  </div>
</template>

<script>
import DecoratorLine from "./DecoratorLine.vue";
export default {
  name: "BlockHeader",
  components: { DecoratorLine },
  props: {
    title: String,
    subtitle: String,
    subtitleEn: String,
  },
  data() {
    return {};
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {},
  },
  computed: {},
};
</script>

<style scoped>
.block-header {
  position: relative;
  z-index: 1;
  text-align: center;
  width: 100%;
}
.block-icon {
  position: relative;
  width: 70px;
  height: 70px;
  margin: 0 auto 20px;
}
.block-icon i {
  position: relative;
  z-index: 2;
  font-size: 2rem;
  color: #9a1b1e;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  background: rgba(154, 27, 30, 0.08);
  border-radius: 50%;
  border: 2px solid rgba(154, 27, 30, 0.15);
  transition: all 0.3s;
}
.block-header:hover .block-icon i {
  background: rgba(154, 27, 30, 0.15);
  transform: scale(1.1) rotate(5deg);
  box-shadow: 0 0 20px rgba(154, 27, 30, 0.2);
  border-color: rgba(154, 27, 30, 0.3);
}
.icon-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(154, 27, 30, 0.15) 0%,
    transparent 70%
  );
  filter: blur(8px);
  animation: iconGlow 2s infinite alternate;
}
@keyframes iconGlow {
  from {
    opacity: 0.3;
    transform: translate(-50%, -50%) scale(0.9);
  }
  to {
    opacity: 0.6;
    transform: translate(-50%, -50%) scale(1.1);
  }
}
.block-title {
  font-size: 1.8rem;
  font-weight: 700;
  color: #222;
  margin-bottom: 5px;
}

.block-subtitle {
  font-size: 0.8rem;
  color: #666;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 500;
}

.block-title-sub {
  font-weight: 700;
  font-size: 1.2rem;
}
</style>
